const About=()=>{

    return (
        <div id='About'>
            <p id='About-heading'>About Gauri</p>
             <div id='about-container'>
               <p className="about-content-1 " >Gauri Mandot is a Frontend Developer and CSE graduate from Mungeeram Bangur Memorial University (MBMU).</p>
               <p className="about-content-2 ">She has interned at the Indian Space Research Organisation (ISRO), where she strengthened her technical foundation and real-world problem-solving skills.</p>
               <p className="about-content-1">A consistent high achiever, Gauri is a CBSE Top District Performer, a 3× Award of Excellence recipient, and the Class 10 School Topper.</p>
               <p className="about-content-2">She specializes in building clean, simple, and user-focused interfaces using React.js, JavaScript, HTML, CSS and Redux.</p>
             </div>
        </div>
    );
}

export default About;

